import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FleetChargingFigureService } from 'src/app/_services/fleet-charging-figure.service';
import { BatteryTypeOption, toBatteryTypeFilter, toBatteryTypeSeries } from 'src/app/_shared/utils/battery-type';
import { TransformXAxisPipe } from 'src/app/_shared/pipes/transform-xaxis.pipe';
import { createPlotlyChart } from 'src/app/_shared/plotlyConfig';

@Component({
  selector: 'app-soc-delta-per-charging-procedure-chart',
  templateUrl: './soc-delta-per-charging-procedure-chart.component.html',
  styleUrls: ['./soc-delta-per-charging-procedure-chart.component.scss']
})
export class SocDeltaPerChargingProcedureChartComponent implements OnChanges, OnDestroy {
  private readonly unsubscribe$ = new Subject<void>();
  @Input() fleetId: string[] = [];
  @Input() selectedBatteryTypes: BatteryTypeOption[] = [];
  errorMessage: boolean = false;
  dataLoading: boolean = false;
  chartRange!: { range: [number, number]; };
  
  constructor(
    private readonly fleetChargingFigureService: FleetChargingFigureService
  ) {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
  ngOnChanges(): void {
    this.dataLoading = true;
    this.errorMessage = false;
    this.fleetChargingFigureService.getSocDeltaFleet(this.fleetId, toBatteryTypeFilter(this.selectedBatteryTypes)).pipe(takeUntil(this.unsubscribe$)).subscribe(
      {
        next: (datapoints) => {
          this.plotsocdeltapercharging(datapoints);
        },
        error: (error) => {
          console.error('Error fetching State of Charge Difference Fleet data:', error);
          this.dataLoading = false;
          this.errorMessage = true;
        },
        complete: () => {
          this.dataLoading = false;
        }
      }
    )
  }
  
  plotsocdeltapercharging(datapoints: any) {
    const transformXAxisPipe = new TransformXAxisPipe();
    const data = toBatteryTypeSeries(datapoints, this.selectedBatteryTypes).map((series) => ({
      x: series.datapoints.map((dataObject: any) => dataObject.binSocDifference),
      y: series.datapoints.map((dataObject: any) => dataObject.chargingSessions),
      type: 'bar',
      name: series.label,
      marker: {
        color: series.color
      }
    }));
    this.chartRange = transformXAxisPipe.transform(data.flatMap((trace) => trace.x), data.flatMap((trace) => trace.y), 5, 100);
    
    const layout = {
      title: 'State of Charge Difference per Charging Session',
      font: {
        family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
        size: 13,
      },
      barmode: 'group',
      xaxis: {
        title: 'State of Charge Increase [%]',
        range: this.chartRange?.range
      },
      yaxis: {
        title: 'Percentage of Charging Sessions [%]'
      },
      showlegend: true,
      legend: {
        orientation: 'h', 
        y: -0.3, 
        xanchor: 'center', 
        x: 0.5,
        font: {
          family: 'boschsans, Helvetica Neue, Helvetica, Arial, sans-serif',
          size: 13,
        },
      }
    };
    
    createPlotlyChart('soc-delta-per-charging-procedure', data, layout);
    
  }
}